import { render, staticRenderFns } from "./InfoLinkAction.vue?vue&type=template&id=25313168&scoped=true"
import script from "./InfoLinkAction.vue?vue&type=script&lang=js"
export * from "./InfoLinkAction.vue?vue&type=script&lang=js"
import style0 from "./InfoLinkAction.vue?vue&type=style&index=0&id=25313168&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25313168",
  null
  
)

export default component.exports